import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherThoughtsQuote = () => {
  const { profileDetails } = useProfileContext()
  const quote = profileDetails?.teacher?.thoughtsQuote

  if (!quote) return null

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10">
        <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
          Teacher&apos;s thoughts
        </h2>
        <blockquote className="border-l-4 border-orange pl-4 text-grey-900 text-base whitespace-pre-line italic leading-relaxed">
          &ldquo;{quote}&rdquo;
        </blockquote>
      </section>
    </>
  )
}

export default React.memo(TeacherThoughtsQuote)
